module.exports = __webpack_public_path__ + "static/img/TaskMonitoringAndAlerting.0e4c9fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TaskMonitoringAndAlerting.png
// module id = GAcW
// module chunks = 1